import Vue from 'vue';
import '@mdi/font/css/materialdesignicons.css';
import Vuetify from 'vuetify/lib/framework';
import zhHans from 'vuetify/es5/locale/zh-Hans';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { zhHans },
        current: 'zhHans',
    },
    theme: {
        dark: false,
        default: 'light',
        themes: {
            light: {
                primary: '#37B7F4',
                secondary: '#03a9f4',
                accent: '#3f51b5',
                error: '#FF1744',
                warning: '#FF6722',
                info: '#2196F3',
                success: '#4CAF50',
            },
        },
    },
    icons: {
        iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
        values: {
            member: 'M12,4A3,3,0,1,1,9,7a3,3,0,0,1,3-3m0-1.5A4.5,4.5,0,1,0,16.5,7,4.49,4.49,0,0,0,12,2.5Z M14.6,14.5c1.89,0,2.93,0,3.43.3a3.08,3.08,0,0,1,1.15,1.43A11.65,11.65,0,0,1,19.5,20H4.5a11.65,11.65,0,0,1,.32-3.77A3.08,3.08,0,0,1,6,14.8c.5-.3,1.54-.3,3.43-.3h5.2m0-1.5H9.4c-2.24,0-3.36,0-4.22.53a4.54,4.54,0,0,0-1.74,2.12C3,16.69,3,18.05,3,20.77v.73H21v-.73c0-2.72,0-4.08-.44-5.12a4.54,4.54,0,0,0-1.74-2.12C18,13,16.84,13,14.6,13Z',
            // 登录页面密码
            password: 'M19.8,10H17.75V8.25a5.75,5.75,0,0,0-11.5,0V10h-2A1.2,1.2,0,0,0,3,11.2v9.1a1.2,1.2,0,0,0,1.2,1.2H19.8A1.2,1.2,0,0,0,21,20.3V11.2A1.2,1.2,0,0,0,19.8,10Zm-12-1.75a4.25,4.25,0,0,1,8.5,0V10H7.75ZM19.5,20H4.5V11.5h15Z M12,18.25a.76.76,0,0,1-.75-.75v-3a.75.75,0,0,1,1.5,0v3A.76.76,0,0,1,12,18.25Z',
            arrowDown: 'M7,10L12,15L17,10H7Z',
        },
    },
});
